
        function HelpTip({ text, align }) {
            if (!text) return null;
            return (
                <span className={"help-tip" + (align === 'right' ? ' right' : '')} tabIndex={0} role="note" aria-label={text}>
                    <span className="help-tip-mark" aria-hidden="true">?</span>
                    <span className="help-tip-bubble">{text}</span>
                </span>
            );
        }

export { HelpTip };
